package org.example.project.enginetabular

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.example.project.manager.LumaticaApiManager
import org.example.project.manager.LumaticaApiSettings
import org.w3c.fetch.RequestInit

suspend fun loadWithTabularFilters(
    endpoint: String,
    filters: Map<String, String>,
    context: Map<String, String> = emptyMap()
): String {
    val body = buildJsonObject {
        put("tabular", true)
        putJsonObject("filters") {
            filters.forEach { (header, value) -> put(header, value) }
        }
        putJsonObject("context") {
            context.forEach { (key, value) -> put(key, value) }
        }
    }.toString()
    val response = window.fetch(
        "${LumaticaApiSettings.getBaseUrl()}/api/$endpoint",
        RequestInit(
            method = "POST",
            headers = LumaticaApiManager.auditHeaders("application/json"),
            body = body
        )
    ).await()
    return response.text().await()
}
